export const LOADER_COURSES = 'LOADER_COURSES';
export const GET_COURSES = 'GET_COURSES';
export const COURSES_FAIL = 'COURSES_FAIL';
export const SAVE_LOADER_COURSES = 'SAVE_LOADER_COURSES';
export const FORM_COURSES_FAIL = 'FORM_COURSES_FAIL';
export const LOADER_COURSES_EMPLOYEES = 'LOADER_COURSES_EMPLOYEES';
export const GET_COURSES_EMPLOYEES = 'GET_COURSES_EMPLOYEES';
export const COURSES_EMPLOYEES_FAIL = 'COURSES_EMPLOYEES_FAIL';
export const LOADER_ENROLLMENT = 'LOADER_ENROLLMENT';
export const ENROLLMENT_SUCCESS = 'ENROLLMENT_SUCCESS';
export const ENROLLMENT_FAIL = 'ENROLLMENT_FAIL';
export const LOADER_REGISTERED_EMPLOYEES = 'LOADER_REGISTERED_EMPLOYEES';
export const GET_REGISTERED_EMPLOYEES = 'GET_REGISTERED_EMPLOYEES';
export const REGISTERED_EMPLOYEES_FAIL = 'REGISTERED_EMPLOYEES_FAIL';
export const LOADER_ENROLLED_EMPLOYEES = 'LOADER_ENROLLED_EMPLOYEES';
export const GET_ENROLLED_EMPLOYEES = 'GET_ENROLLED_EMPLOYEES';
export const ENROLLED_EMPLOYEES_FAIL = 'ENROLLED_EMPLOYEES_FAIL';
export const LOADER_APPROVE_ENROLLMENT = 'LOADER_APPROVE_ENROLLMENT';
export const APPROVE_ENROLLMENT_SUCCESS = 'APPROVE_ENROLLMENT_SUCCESS';
export const APPROVE_ENROLLMENT_FAIL = 'APPROVE_ENROLLMENT_FAIL';